/** Canonical asset families used by deposit and withdrawal flows. */
const CANONICAL_SYMBOL_BY_VARIANT: Readonly<Record<string, string>> = {
  BTCB: "BTC",
  CBBTC: "BTC",
  WBTC: "BTC",
  WETH: "ETH",
};

/** Assets whose canonical external chain cannot be inferred from the symbol. */
export const CANONICAL_ASSETS: Readonly<Record<string, string>> = {
  "AAVE.ETH": "AAVE",
  "DAI.ETH": "DAI",
  "FOX.ETH": "FOX",
  "GUSD.ETH": "GUSD",
  "LINK.ETH": "LINK",
  "LUSD.ETH": "LUSD",
  "TGT.ETH": "TGT",
  "THOR.ETH": "THOR",
  "USDC.ETH": "USDC",
  "USDT.ETH": "USDT",
  "USDP.ETH": "USDP",
  "VTHOR.ETH": "VTHOR",
  "WBTC.ETH": "WBTC",
  "YFI.ETH": "YFI",
  "cbBTC.BASE": "cbBTC",
  "BNB.BSC": "BNB",
  "ATOM.GAIA": "ATOM",
};

export const canonicalAssetSymbol = (symbol: string): string => {
  const normalized = symbol.toUpperCase();
  return CANONICAL_SYMBOL_BY_VARIANT[normalized] || normalized;
};

export const isSameCanonicalAsset = (left: string, right: string): boolean =>
  canonicalAssetSymbol(left) === canonicalAssetSymbol(right);

export const canonicalChainFor = (symbol: string): string => {
  const normalized = symbol.toUpperCase();
  for (const [key, candidate] of Object.entries(CANONICAL_ASSETS)) {
    if (candidate.toUpperCase() === normalized) return key.split(".")[1];
  }
  return symbol;
};
